module.exports = __WEBPACK_EXTERNAL_MODULE__libs_logger__;